import request from '@/utils/request'

export function login(params) {
  return request({
    url: '/login',
    method: 'post',
    params: params
  })
}
export function logout(token) {
    return request({
      url: '/logoutToken',
      method: 'get',
      params: { token }
    })
}
// 获取用户个人信息
export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}